import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["FormControl", "showLabel", "children", "className"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const RuleBox = props => {
  const {
      FormControl = UIFormControl,
      showLabel = false,
      children,
      className = ''
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    label: showLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.options.usersAndTeams"
    }) : null,
    className: `m-y-4 ${className}`
  }, rest, {
    children: children
  }));
};
RuleBox.displayName = 'RuleBox';
export default RuleBox;